<div fxFill fxLayout="row" fxLayout.lt-md="column" fxFlexLayoutGap="0.5rem">
  <div fxFlex="75%" fxFlexOrder.xs="2" class="login-presentation">
    <app-presentation (openWebsiteEvent)="openWebsite()" (contactEvent)="contact()" (helpEvent)="getHelp()"> </app-presentation>
  </div>
  <div fxFlex fxFlexOrder.xs="1" class="login-container">
    <app-login [isLoading]="isLoading" (loginEvent)="login($event)" (recoverPasswordEvent)="recoverPassword()">
    </app-login>
  </div>
</div>
